import * as loadingAction from "../../../../store/loading/action";
import * as messageAction from "../../../../store/message/action";
import * as summaryReportAction from "../../../../store/summary-report/action";

import {
  Button,
  Card,
  CardBody,
  Col,
  Input,
  Modal,
  Row,
  Table,
} from "reactstrap";
import {
  GET_DT_DEMAND_COLUMN,
  GET_RP_AVG_DEMAND,
  GET_RP_AVG_DEMAND_EVENT,
  GET_RP_AVG_DEMAND_YEAR_TO_TODAY,
} from "helpers/url_api_constant";
import React, { useEffect, useState, useMemo } from "react";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import debounce from "lodash.debounce";
import BootstrapTable from "react-bootstrap-table-next";
import PropTypes from "prop-types";
import { colorOption } from "components/Custom/SelectColor";
import moment from "moment";
import { post } from "helpers/api_helper";
import { set } from "lodash";
import { useDispatch } from "react-redux";

function DemandComparison(props) {
  // console.log(props);
  const dispatch = useDispatch();
  // const [searchDate, setSearchDate] = useState(moment(new Date().setDate(new Date().getDate() - 1)).format(
  //     "YYYY-MM-DD"));

  const defualtAvgDemandEventModel = {
    PID: "",
    SUMMARYREPORT_PID: props.summaryReportPid,
    AVGDEMAND_STATUS: 0,
    AVGDEMAND_REMARK: "",
  };
  const [modelDeviceList, setModelDeviceList] = useState([]);
  const [avgDemandEventModel, setAvgDemandEventModel] = useState(
    defualtAvgDemandEventModel
  );
  const [columnDataList, setColumnDataList] = useState([]);
  const [avgDemandYearToToDay, setAvgDemandYearToToDay] = useState(0);
  const [dataList, setDataList] = useState([]);
  const [columnRenderList, setColumnRenderList] = useState([
    {
      dataField: "year",
      text: "",
      headerAlign: "center",
      editable: false,
      align: "center",
      headerStyle: {
        backgroundColor: colorOption[0].label,
        width: "2%",
      },
    },
  ]);

  //sort Column//

  //sort Column//

  useEffect(() => {
    fetchData();
  }, [props.summaryReportPid]);

  useEffect(() => {
    renderColumn();
  }, [columnDataList]);
  useEffect(() => {
    generateRow();
  }, [dataList]);

  const rowStyleDemandCom = (row, rowIndex) => {
    const style = {};

    style.color = "#FFFFFF";

    return style;
  };

  function numberFormat(number, digit = 2) {
    if (number === null || number === "null" || number === "") return "";
    function isFloat(n) {
      return Number(n) === n && n % 1 !== 0;
    }
    if (isFloat(number))
      return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
        minimumFractionDigits: digit,
      });
    return parseFloat(number).toLocaleString(undefined, {
      minimumFractionDigits: digit,
    });
  }
  const ToNumberFormat = (cell, row, rowIndex) => numberFormat(cell, 2);
  const getColumn = () => post(GET_DT_DEMAND_COLUMN, {});
  //headerColumn
  const fetchData = async () => {
    dispatch(loadingAction.showLoading());
    setAvgDemandEventModel(defualtAvgDemandEventModel);
    try {
      let column = await getColumn();
      setColumnDataList(
        column.data.dtKeyinDemandColumnList.map((obj, index) => ({
          ...obj,
          ROW: index + 1,
        }))
      );
      let [avgDemand, avgDemandEvent, avgDemandYearToToDay] = await Promise.all(
        [
          post(GET_RP_AVG_DEMAND, {
            SUMMARYREPORT_PID:
              props.summaryReportPid || "f126e98a-3529-4a47-b497-4cba630d6682",
          }),
          post(GET_RP_AVG_DEMAND_EVENT, {
            SUMMARYREPORT_PID:
              props.summaryReportPid || "f126e98a-3529-4a47-b497-4cba630d6682",
          }),
          post(GET_RP_AVG_DEMAND_YEAR_TO_TODAY, {
            SUMMARYREPORT_PID:
              props.summaryReportPid || "f126e98a-3529-4a47-b497-4cba630d6682",
          }),
        ]
      );

      // console.log(avgDemandEvent);
      // console.log(avgDemand.data.rpAVGDemandModList)
      setDataList(avgDemand.data.rpAVGDemandModList);
      if (avgDemandEvent.data.rpAVGDemandEventList.length == 1) {
        setAvgDemandEventModel(avgDemandEvent.data.rpAVGDemandEventList[0]);
      }

      setAvgDemandYearToToDay(avgDemandYearToToDay.data);
      // console.log(avgDemandYearToToDay);
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };
  const renderColumn = () => {
    // console.log(columnDataList)
    setColumnRenderList([
      {
        dataField: "year_text",
        text: "",
        headerAlign: "center",
        editable: false,
        align: "center",
        headerStyle: {
          color: "#46FCFF",
          backgroundColor: colorOption[0].label,
        },
      },
      ...columnDataList
        .sort((a, b) =>
          a.DEMANDCOLUMN_ORDER > b.DEMANDCOLUMN_ORDER
            ? 1
            : b.DEMANDCOLUMN_ORDER > a.DEMANDCOLUMN_ORDER
            ? -1
            : 0
        )
        .filter(
          obj =>
            obj.DEMANDCOLUMN_SHOW == true || obj.DEMANDCOLUMN_SHOW == "true"
        )
        .map(obj => ({
          dataField: obj.DEMANDCOLUMN_NAME.replaceAll(".", "_"),
          text: obj.DEMANDCOLUMN_ALIAS,
          headerAlign: "center",
          editable: false,
          align: "center",
          headerStyle: {
            color: "#46FCFF",
            backgroundColor: colorOption[obj.DEMANDCOLUMN_TYPE].label,
          },
          formatter: ToNumberFormat,
        })),
      {
        dataField: "Total",
        text: "Total",
        headerAlign: "center",
        editable: false,
        align: "center",
        headerStyle: {
          color: "#46FCFF",
          backgroundColor: "#556ee6",
        },
        formatter: ToNumberFormat,
      },
    ]);
  };
  const generateRow = () => {
    function getDaysInMonth(year) {
      let preventYear = year - 1;
      let yearList = [];

      for (let index = preventYear; index <= year; index++) {
        yearList.push({
          year: index,
          year_text:
            index == preventYear
              ? `AVG ${index}`
              : moment(props.date).locale("en").format("D MMM YYYY"),
        });
      }
      yearList.push({
        year: 9999,
        year_text: `Diff`,
      });
      //   console.log(yearList)
      return yearList;
    }

    let dayList;
    let startYear = moment(props.date).format("YYYY");

    dayList = getDaysInMonth(startYear);
    dayList = addFieldToModelDeviceList(dayList);
    //   console.log(dayList)
    setModelDeviceList(dayList);
  };

  const addFieldToModelDeviceList = rowList => {
    function sumDataColumn(list) {
      // console.log(list)
      let fieldNotSum = [
        "ROW",
        "PID",
        "year",
        "year_text",
        "DEMAND_DATE",
        "DEMANDCOLUMN_PID",
        "DEMANDCOLUMN_ORDER",
        "DEMANDCOLUMN_NAME",
        "DEMAND_YEAR",
        "DEMAND_DATA",
        "PRIORITY_FLAG",
        "STATUS_FLAG",
        "GMDR_NAME",
        "GMDR_DATA",
        "SCADA_NAMEs",
        "SCADA_DATA",
        "FLOW_DATA",
        "Total",
      ];
      let data = list.map(row => {
        let sumTotal = 0;

        for (const property in row) {
          if (typeof row[property] != "object") {
            // console.log(fieldNotSum.indexOf(property),property)
            if (fieldNotSum.indexOf(property) == -1) {
              // console.log(row[property])
              sumTotal += parseFloat(row[property]);
            }
          }
        }
        return { ...row, Total: sumTotal };
      });
      return data;
    }
    let dataModel = {
      PID: "",
      DEMAND_DATE: "",
      DEMANDCOLUMN_PID: "",
      DEMANDCOLUMN_ORDER: 0,
      DEMANDCOLUMN_NAME: "",
      DEMAND_YEAR: "",
      DEMAND_DATA: 0,
      PRIORITY_FLAG: 0,
      STATUS_FLAG: 0,
      GMDR_NAME: "",
      GMDR_DATA: 0,
      SCADA_NAME: "",
      SCADA_DATA: 0,
      FLOW_DATA: 0,
    };
    if (rowList.length > 0) {
      // console.log(dataList)
      let data = dataList;
      let modelList = [];
      columnDataList.map(objColumn => {
        modelList = [
          ...rowList.map((obj, index) => {
            let value = data.find(
              value => value.DEMANDCOLUMN_PID == objColumn.PID
            );
            let total = 0;
            let DEMAND_DATA = 0;
            if (value) {
              switch (index) {
                case 0:
                  DEMAND_DATA = value.DEMAND_AVG_DATA;
                  break;
                case 1:
                  DEMAND_DATA = value.DEMAND_DATA;
                  break;
                default:
                  DEMAND_DATA = value.DEMAND_DIFF;

                  break;
              }
            }
            obj[objColumn.DEMANDCOLUMN_NAME.replaceAll(".", "_")] = DEMAND_DATA;
            obj[`${objColumn.DEMANDCOLUMN_NAME.replaceAll(".", "_")}__data`] = {
              ...dataModel,
              ...value,
              DEMAND_DATE: obj.DEMAND_DATE,
              DEMAND_YEAR: obj.DEMAND_YEAR,
              DEMANDCOLUMN_PID: objColumn.PID,
              DEMANDCOLUMN_ORDER: objColumn.DEMANDCOLUMN_ORDER,
              DEMANDCOLUMN_NAME: objColumn.DEMANDCOLUMN_NAME,
            };
            return { ...obj, Total: total };
          }),
        ];
      });
      modelList = sumDataColumn(modelList);
      return modelList;
    }
  };

  const setDispatchAction = useMemo(
    () =>
      debounce(value => {
        dispatch(summaryReportAction.setAVGDemandEventToState(value));
      }, 300),
    []
  );

  useEffect(() => {
    setDispatchAction(avgDemandEventModel);
  }, [avgDemandEventModel]);

  // useEffect(() => {
  //   dispatch(summaryReportAction.setAVGDemandEventToState(avgDemandEventModel));
  //   // console.log(avgDemandEventModel)
  // }, [avgDemandEventModel]);

  return (
    <div>
      <Row className="mt-1">
        <Col sm="6" className="d-flex align-items-center justify-content-start">
          <h5 className="mb-0 sm-0 font-size-15 " style={{ color: "#46FCFF" }}>
            Demand Comparison For Different Customer Types
          </h5>
        </Col>
        <Col sm="2" className="d-flex align-items-center justify-content-end">
          <h5 className="mb-0 sm-0 font-size-15" style={{ color: "#46FCFF" }}>
            Unit : MMscfd
          </h5>
        </Col>
      </Row>

      <Row className="mt-1">
        <Col lg="8">
          <div>
            <BootstrapTable
              classes="mb-0"
              keyField="year"
              data={modelDeviceList}
              columns={columnRenderList}
              headerClasses="header-style"
              rowStyle={rowStyleDemandCom}
              // defaultSorted={defaultSorted}
              // pagination={paginationFactory(options)
            />
          </div>
          <div className="table-responsive mt-0 pt-0">
            <Table className="table table-bordered mb-0 mt-0 pt-0">
              <tbody style={{ color: "#FFFFFF", textAlign: "center" }}>
                <tr style={{ backgroundColor: "#556ee64a" }}>
                {/* #556ee630 */}
                  <td
                    colSpan={columnRenderList.length}
                    style={{ textAlign: "right" }}
                  >
                    Actual Delivery (Of Year to Date.)
                  </td>
                  <td style={{ width: "9%" }}>
                    {numberFormat(avgDemandYearToToDay, 2)}
                    {/* {numberFormat(modelDeviceList.reduce((total,item)=>(total+item.Total),0)) } */}
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        </Col>
        <Col lg="4">
          <div className="table-responsive">
            <Table className="table table-bordered mb-0">
              <thead>
                <tr>
                  {/* <th>#</th> */}
                  <th
                    style={{
                      backgroundColor: "#556ee64a",
                      color: "#46FCFF",
                      textAlign: "center",
                      width: "50%",
                    }}
                  >
                    Event Report
                  </th>
                  <th
                    style={{
                      backgroundColor: "#556ee64a",
                      color: "#46FCFF",
                      textAlign: "center",
                      width: "50%",
                    }}
                  >
                    {moment(props.date).locale("en").format("D MMM YYYY")}
                  </th>
                </tr>
              </thead>
              <tbody style={{ color: "#FFFFFF", textAlign: "center" }}>
                <tr>
                  <td colSpan={2} style={{ height: "50px" }}>
                    <Col sm={12}>
                      <input
                        className="form-check-input"
                        type="radio"
                        name="AVGDEMAND_STATUS"
                        id="exampleRadios"
                        checked={avgDemandEventModel.AVGDEMAND_STATUS == 0}
                        onChange={() =>
                          setAvgDemandEventModel({
                            ...avgDemandEventModel,
                            AVGDEMAND_STATUS: 0,
                          })
                        }
                      />
                      <label
                        className="form-check-label ms-2"
                        htmlFor="exampleRadios"
                      >
                        Normal
                      </label>
                      <input
                        className="form-check-input ms-5"
                        type="radio"
                        id="exampleRadios1"
                        name="AVGDEMAND_STATUS"
                        checked={avgDemandEventModel.AVGDEMAND_STATUS == 1}
                        onChange={() =>
                          setAvgDemandEventModel({
                            ...avgDemandEventModel,
                            AVGDEMAND_STATUS: 1,
                          })
                        }
                      />
                      <label
                        className="form-check-label ms-2"
                        htmlFor="exampleRadios1"
                      >
                        Abnormal
                      </label>
                    </Col>
                  </td>
                </tr>
                <tr>
                  <td colSpan="2" style={{ height: "145px" }}>
                    <Col sm={12}>
                      <Input
                        placeholder="-"
                        type="textarea"
                        rows="5"
                        style={{
                          border: "solid 1px #FFFFFF",
                          color: "#FFFFFF",
                        }}
                        className="form-control"
                        onChange={e =>
                          setAvgDemandEventModel({
                            ...avgDemandEventModel,
                            AVGDEMAND_REMARK: e.target.value,
                          })
                        }
                        value={avgDemandEventModel.AVGDEMAND_REMARK}
                      />
                    </Col>
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        </Col>
      </Row>
    </div>
  );
}

DemandComparison.propTypes = {
  t: PropTypes.any,
  date: PropTypes.any,
  summaryReportPid: PropTypes.any,
};

export default DemandComparison;
